module.exports = __webpack_public_path__ + "img/ic_wallet.caf96d7c.png";